import { Terms } from "../../types/terms";

const terms: Terms = {
  absoluteChange: "Absolute Change",
  automatedResilience: "Automated Resilience",
  resilience: "Resilience",
  adaptationTypes: {
    baseline: "Baseline",
    low_resilience: "Low Resilience",
    modern_resilience: "Modern Resilience",
    enhanced_resilience: "Enhanced Resilience",
  },
  relativeChange: "Relative Change",
  address: "Address",
  analysisId: "Analysis ID",
  archetype: "Archetype",
  archetypeCategories: {
    commercial: "Commercial",
    industrial: "Infrastructure",
    residential: "Residential",
  },
  asset: "Asset",
  assetArchetype: "Asset Type (Archetype)",
  assetUncertainty: "Asset Uncertainty",
  assetLevel: "Point-Level Results",
  buildYear: "Build Year",
  chart: "Chart",
  coordinates: "Coordinates",
  cost: "Cost",
  count: "Count",
  documents: {
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
  },
  element: "Element",
  elevation: "Elevation",
  elevationDataset: "Elevation Source",
  fireProtection: "Fire Protection",
  foundationDesign: "Foundation Design",
  geocodeQuality: "Geocode Quality",
  hazard: "Hazard",
  hazards: {
    all: "All Hazards",
    coastalInundation: "Coastal Inundation",
    cycloneWind: "Tropical Cyclone Wind",
    extremeHeat: "Extreme Heat",
    heatFailure: "Extreme Heat Failure", // alternative to extremeHeat
    extremeWind: "Extreme Wind",
    forestFire: "Forest Fire",
    freezeThaw: "Freeze-Thaw",
    landslide: "Landslide",
    riverineFlood: "Riverine Flood",
    soilMovement: "Soil Movement",
    surfacewaterFlooding: "Surface Water Flood",
    tcss: "Tropical Cyclone Storm Surge",
  },
  heightAboveGround: "Floor Height Above Ground",
  id: "ID",
  latitude: "Latitude",
  latLong: "Latitude & Longitude",
  lgd: "Loss Given Default",
  lgdShort: "LGD",
  list: "List",
  loanToValue: "Loan-to-Value",
  location: "Location",
  longitude: "Longitude",
  map: "Map",
  marketValue: "Market Value",
  material: "Material",
  modules: "Modules",
  mortgageBalance: "Mortgage Balance",
  mortgageRate: "Mortgage Rate",
  name: "Name",
  notUsed: "Not Used",
  pd: "Probability of Default",
  pdShort: "PD",
  portfolioTypes: {
    global: {
      title: "Global",
      description: "Global risk analysis with 46 generic global archetypes & extended asset-level outputs.",
    },
    hk: {
      title: "HKSAR",
      description: "Region-specific risk analysis with 5-tier ratings and 6 customised Hong Kong archetypes.",
    },
  },
  preview: "Preview",
  rcp: "Representative Concentration Pathway",
  rcpShort: "RCP",
  replacementCost: "Replacement Cost",
  returnFrequency: "Return Frequency",
  returnPeriod: "Return Period",
  risk: "Risk",
  riskBands: "Risk Bands",
  simpleRiskRatings: "Simple Risk Ratings",
  scenarios: {
    rcp26: {
      name: "rcp26_ssp1-2.6",
      long: "XDI RCP 2.6 / SSP1-2.6 aligns with NGFS Net Zero 2050",
      medium: "RCP 2.6 / SSP1-2.6 (Net Zero 2050)",
      short: "RCP2.6/SSP1-2.6",
      gwl: "Low warming +0.9°C – +2.4°C by 2100",
    },
    rcp45: {
      name: "rcp45_ssp2-4.5",
      long: "XDI RCP 4.5 / SSP2-4.5 aligns with NGFS Delayed Transition",
      medium: "RCP 4.5 / SSP2-4.5 (Delayed Transition)",
      short: "RCP4.5/SSP2-4.5",
      gwl: "Moderate warming +1.7°C – +3.3°C by 2100",
    },
    rcp60: {
      name: "rcp60_ssp3-7.0",
      long: "XDI RCP 6.0 aligns with NGFS Current Policies (median)",
      medium: "RCP 6.0 (Current Policies Median Range)",
      short: "RCP6.0",
      gwl: "High warming +2.0°C – +3.8°C by 2100",
    },
    rcp85: {
      name: "rcp85_ssp5-8.5",
      long: "XDI RCP 8.5 / SSP5-8.5 aligns with NGFS Current Policies (high range)",
      medium: "RCP 8.5 / SSP5-8.5 (Current Policies High Range)",
      short: "RCP8.5/SSP5-8.5",
      gwl: "Peak warming +3.2°C – +5.4°C by 2100",
    },
  },
  stage: "Stage",
  status: {
    error: "Error",
    pending: "Pending",
    processing: "Processing",
    provisioning: "Provisioning",
    success: "Success",
    unknown: "Unknown",
    uploading: "Uploading",
    warning: "Warning",
  },
  subtitle: "Subtitle",
  title: "Title",
  temperature: "Temperature",
  threshold: "Threshold",
  topDecileAbsoluteChange: "Top 10% Absolute Change",
  type: "Type",
  units: {
    celsius: "degree celsius",
    celsiusSymbol: "°C",
    metres: "metres",
    metresPerSecond: "metres per second",
    metresPerSecondSymbol: "m/s",
  },
  userSuppliedId: "User Supplied ID",
  value: "Value",
  windSpeed: "Wind Speed",
};

export default terms;
